module.exports = __webpack_public_path__ + "img/shirt-tank-top.2e26f322.svg";